<script setup>
import Footer from '@/components/Footer/Footer.vue';
import Header from '@/components/Header/Header.vue';
import SportLiveTvCatalog from '@/sport-live-tv/components/sport-live-tv-catalog.vue';
import { useSportLiveTvTranslation } from '@/sport-live-tv/composables/use-sport-live-tv-translation';

const { t } = useSportLiveTvTranslation();
</script>

<template>
  <div class="db">
    <div class="header-wrap">
      <Header hide-search />
    </div>
    <main class="mainView sport-live-tv-page">
      <h1 class="sport-live-tv-page__title">{{ t('title') }}</h1>
      <SportLiveTvCatalog />
    </main>
    <Footer class="member-footer" />
  </div>
</template>

<style lang="scss" scoped>
.sport-live-tv-page {
  padding-right: 4%;
  padding-bottom: 48px;
  padding-left: 4%;

  &__title {
    margin: 24px 0 32px;
    color: $white;
    font-size: 32px;
    font-weight: 700;
  }
}
</style>
